import { AbstractControl, ValidatorFn } from '@angular/forms';

export class DateValidators {
    static dateLessThan(dateField: string): ValidatorFn {
        return (c: AbstractControl): { [key: string]: boolean } | null => {
            const date2 = c.parent?.get(dateField).value;
            if (c.value !== null && date2 !== null && c.value > date2) {
                return { dateHasToBeLess: true };
            }
            return null;
        };
    }
}
